import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const MessageCloudIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ height = 12, width = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 12 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M1.5 9.00004L2.15 7.05004C1.58822 6.21918 1.385 5.23525 1.57811 4.28119C1.77122 3.32713 2.34753 2.46788 3.19988 1.86318C4.05224 1.25848 5.12263 0.949488 6.21204 0.99366C7.30146 1.03783 8.33576 1.43216 9.12264 2.10332C9.90952 2.77448 10.3954 3.67681 10.49 4.64253C10.5846 5.60825 10.2815 6.57165 9.63694 7.3536C8.99239 8.13555 8.05033 8.68284 6.9859 8.89372C5.92147 9.10459 4.8071 8.96469 3.85 8.50004L1.5 9.00004Z"
          stroke="white"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
